import { IconUserPlus } from '@tabler/icons-react'
import { Button } from '@/components/ui/button'
import { useClients } from '../context/client-context'
import { useTranslation } from 'react-i18next'
import { PermissionGuard } from '@/components/permission-guard'
import { UserPermission } from '@/constants/permissions'

export function ClientsPrimaryButtons() {
  const { setOpen } = useClients()
  const i18n = useTranslation()
  return (
    <div className='flex gap-2'>
      <PermissionGuard permission={UserPermission.ADD_CLIENT}>
        <Button className='space-x-1' onClick={() => setOpen('add')}>
          <span>{i18n.t('add_client')}</span> <IconUserPlus size={18} />
        </Button>
      </PermissionGuard>
    </div>
  )
}
